module.exports = __webpack_public_path__ + "img/视频封面22.667fae90.png";